import {
  Stack,
  Typography,
  IconButton,
  TextField,
  Button,
  Modal,
} from "@mui/material";
import religueImg from "assets/services/religue.png";
import { useState, useEffect } from "react";
import { RadioButtons } from "components/Inputs/RadioButtons/RadioButtons";
import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { maskPhoneNumber } from "utils/Masks/Masks";
import InfoReconnect from "../InfoReconnect/InfoReconnect";
import { ArrowBack } from "@mui/icons-material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";

export default function Questions({
  onChangePage,
  handleClose,
  handleCloseReconnect,
}) {
  const [hasDoorman, setHasDoorman] = useState("");
  const [hasMeter, setHasMeter] = useState("");
  const [enterQuestion, setEnterQuestion] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [othersAccess, setOthersAccess] = useState("");
  const [openInfoReconnect, setOpenInfoReconnect] = useState(false);
  const [needInfo, setNeedInfo] = useState(false);

  const [questionStep, setQuestionStep] = useState(1);

  useEffect(() => {
    if (hasMeter === "idk") {
      setNeedInfo(true);
    }
  }, [hasMeter]);

  const buttonValidations = () => {
    if (
      questionStep === 1 &&
      hasMeter != "" &&
      questionStep === 2 &&
      hasDoorman === "YES"
    ) {
      return true;
    }

    if (hasDoorman === "NO") {
      if (enterQuestion === "anotherPerson") {
        return Boolean(name.trim() && phone.trim());
      }
      if (enterQuestion === "others") {
        return Boolean(othersAccess.trim());
      }
      if (enterQuestion === "me") {
        return true;
      }
    }

    return hasDoorman === "YES" && hasMeter !== "";
  };

  const handleSubmit = () => {
    if (hasMeter === "YES") {
      return onChangePage("confirmService", {
        hasDoorman,
        hasMeter,
        enterQuestion,
        phone,
        name,
        othersAccess,
      });
    } else {
      return onChangePage("chooseInstallation", {
        hasDoorman,
        hasMeter,
        enterQuestion,
        phone,
        name,
        othersAccess,
      });
    }
  };

  return (
    <>
      <Stack p={" 0px 32px 32px 32px"}>
        <Stack direction={"row"} alignItems={"center"} mb={"18px"}>
          <ArrowBack
            sx={{ fontSize: "30px", marginRight: "12px", cursor: "pointer" }}
            onClick={() => {
              handleClose();
            }}
          />
          <Typography fontSize={"25px"} fontWeight={700} fontStyle={"italic"}>
            RELIGUE
          </Typography>
          <IconButton
            sx={{
              mb: 1,
              ml: 0.2,
            }}
            onClick={() => setOpenInfoReconnect(true)}
          >
            <Tooltip title="Ver mais" placement="top" arrow>
              <HelpIcon
                sx={{
                  color: "#707070",
                  fontSize: "20px",
                }}
              />
            </Tooltip>
          </IconButton>
        </Stack>
        <Typography
          fontSize={"14px"}
          fontWeight={500}
          color="#636363"
          align="justify"
          lineHeight={"100%"}
        >
          Para efetuar o religue deste imóvel, precisamos saber se existe algum
          tipo de medidor já instalado no local. Selecione uma das opções
          abaixo, para detalhar o processo de religue. Este serviço é realizado
          na parte externa do imóvel, portanto, não necessita do acompanhamento
          do morador.
        </Typography>
        <Stack alignItems={"center"} mt={"57px"} mb={"57px"}>
          <img
            src={religueImg}
            alt="Serviço de religue"
            style={{
              width: "340px",
              height: "227px",
            }}
          />
        </Stack>
        <Stack
          direction="column"
          justifyContent="space-between"
          border="1px solid #2CABF9"
          p="16px"
          gap={"30px"}
          borderRadius="16px"
        >
          {questionStep == 1 && (
            <Stack width="100%">
              <Typography
                fontSize="18px"
                fontWeight={600}
                color="#053462"
                mb={"13px"}
              >
                Já existe algum medidor instalado no local?
              </Typography>
              <RadioButtons
                value={hasMeter}
                onChange={(v) => {
                  setHasMeter(v);
                  setHasDoorman("");
                  setEnterQuestion("");
                }}
                options={[
                  { value: "YES", label: "Sim" },
                  { value: "NO", label: "Não" },
                  {
                    value: "idk",
                    label: "Não sei dizer ao certo",
                  },
                ]}
              />
            </Stack>
          )}
        </Stack>
        {questionStep == 1 && hasMeter === "YES" && (
          <Stack
            mt="16px"
            direction="column"
            justifyContent="space-between"
            border="1px solid #2CABF9"
            p="16px"
            borderRadius="16px"
          >
            <Typography
              fontSize="18px"
              fontWeight={600}
              color="#053462"
              mb={"13px"}
            >
              Seu condomínio tem porteiro?
            </Typography>
            <RadioButtons
              value={hasDoorman}
              onChange={setHasDoorman}
              options={[
                { value: "YES", label: "Sim" },
                { value: "NO", label: "Não" },
              ]}
            />
            {hasDoorman === "NO" && (
              <Stack ml={2}>
                <Typography
                  fontSize="12px"
                  fontWeight={500}
                  color="#636363"
                  lineHeight={"100%"}
                >
                  Após abertura de ordem de serviço de religue, nosso técnico
                  realizará o serviço em até 2 dias úteis. Para isso, ele
                  precisará ter acesso ao medidor de gás do local.
                </Typography>
                <Typography
                  fontSize="12px"
                  fontWeight={500}
                  color="#636363"
                  mt={"15px"}
                  lineHeight={"100%"}
                >
                  Informe abaixo como o técnico poderá acessar o local para
                  realizar o atendimento.
                </Typography>
              </Stack>
            )}
          </Stack>
        )}
        {hasDoorman === "NO" && (
          <Stack
            justifyContent="space-between"
            border="1px solid #2CABF9"
            p="16px"
            borderRadius="16px"
            mt={"15px"}
          >
            <Typography
              fontSize="18px"
              fontWeight={600}
              color="#053462"
              mb={"13px"}
            >
              Como o técnico poderá acessar o local para realizar o atendimento?
            </Typography>
            <RadioButtons
              value={enterQuestion}
              onChange={setEnterQuestion}
              options={[
                {
                  value: "me",
                  label: "Estarei no local para receber o técnico",
                },
                {
                  value: "anotherPerson",
                  label: "Outra pessoa estará no local para receber o técnico",
                },
                {
                  value: "others",
                  label: "Outras formas de acesso",
                },
              ]}
            />
            {enterQuestion === "others" && (
              <>
                <Typography
                  fontSize="12px"
                  fontWeight={500}
                  color="#636363"
                  lineHeight={"100%"}
                  mt={"4px"}
                >
                  Para realizar o religue, nosso técnico precisa acessar o
                  medidor do local, mesmo que não haja porteiro ou alguém para
                  liberar a entrada.
                </Typography>
                <Typography
                  fontSize="12px"
                  fontWeight={500}
                  color="#636363"
                  mt={"15px"}
                  lineHeight={"100%"}
                >
                  Informe abaixo como o técnico poderá acessar o medidor, no dia
                  do atendimento.
                </Typography>
                <TextField
                  placeholder="Portão estará aberto, chave estará com vizinho, portão com código de acesso, etc."
                  multiline
                  value={othersAccess}
                  onChange={(e) => {
                    setOthersAccess(e.target.value);
                  }}
                  rows={6}
                  sx={{
                    mt: "8px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#9F9F9F",
                        background: "#63636326",
                      },

                      padding: "10px",
                      fontSize: "12px",
                      "&.Mui-focused": {
                        "& fieldset": {
                          borderColor: "#9F9F9F",
                          borderWidth: 2,
                        },
                      },

                      "& textarea::placeholder": {
                        fontSize: "12px",
                        fontStyle: "italic",
                      },
                    },
                  }}
                />
              </>
            )}
            {enterQuestion === "anotherPerson" && (
              <>
                <Typography
                  fontSize="12px"
                  fontWeight={500}
                  color="#636363"
                  mt={"4px"}
                  lineHeight={"100%"}
                >
                  Confirme os dados de contato da pessoa que o técnico pode
                  procurar em caso de necessidade no dia do atendimento. Essas
                  informações ficam disponíveis em Serviços, na opção
                  Protocolos.
                </Typography>
                <TextField
                  variant="standard"
                  placeholder="Nome completo"
                  color="secondary"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  sx={{
                    mt: "12px",
                  }}
                />
                <TextField
                  placeholder="Telefone"
                  variant="standard"
                  color="secondary"
                  value={phone}
                  onChange={(e) => {
                    const value = maskPhoneNumber(e.target.value);
                    setPhone(value);
                  }}
                  sx={{
                    mt: "28px",
                  }}
                />
              </>
            )}
          </Stack>
        )}
      </Stack>
      <Modal
        open={needInfo}
        onClose={() => setNeedInfo(false)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"675px"}
          style={{ width: "auto" }}
          borderRadius={"8px"}
        >
          <Stack flexDirection={"row"} justifyContent={"end"} padding={"26px"}>
            <IconButton onClick={() => setNeedInfo(false)}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "28px",
                }}
              />
            </IconButton>
          </Stack>
          <Stack pt={"16px"} px={"40px"} pb={"40px"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              mb={"32px"}
            >
              <Typography fontSize={"32px"} fontWeight={700}>
                Informação necessária para religue
              </Typography>
            </Stack>
            <Typography
              fontSize={"18px"}
              fontWeight={500}
              color="#636363"
              align="flex-start"
              lineHeight={"115%"}
            >
              Para que possamos avançar com o religue, precisamos da informação
              referente a existência de medidor instalado no local, essa
              informação pode ser adquirida junto ao síndico ou zelador do seu
              condomínio.
            </Typography>
          </Stack>
          <Stack pb={"40px"} pt={"20px"}>
            <Stack alignItems={"center"} px={"24px"}>
              <Button
                variant="contained"
                color="secondary"
                sx={{
                  color: "#fff",
                  height: "56px",
                  width: "100%",
                  borderRadius: "36px",
                }}
                onClick={() => {
                  setNeedInfo(false);
                  handleCloseReconnect();
                }}
              >
                ENTENDI
              </Button>
            </Stack>
          </Stack>
        </ContentModal>
      </Modal>
      <Stack height={"135px"} bgcolor={"#053462"}>
        <Stack alignItems={"center"}>
          <Stack alignSelf={"center"} mt={"25px"} mb={"28px"}>
            <button
              className="inline-link"
              onClick={() => window.open("/warranty-terms", "_blank")}
            >
              Termos de garantia
            </button>
          </Stack>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              handleSubmit();
            }}
            disabled={!buttonValidations()}
            sx={{
              color: "#fff",
              height: "45px",
              width: "358px",
              borderRadius: "36px",
            }}
          >
            Contratar
          </Button>
        </Stack>
      </Stack>
      <InfoReconnect
        open={openInfoReconnect}
        onClose={() => setOpenInfoReconnect(false)}
      />
    </>
  );
}
